import Vue from 'vue';
export const clone = object => JSON.parse(JSON.stringify(object));
export const map = (array) => {
  const map = {};
  array.forEach((item) => {
    map[item.id] = item;
  });
  return map;
};
export const array = (map) => {
  const array = [];
  for (const key in map) {
    array.push(map[key]);
  }
  return array;
};
export const reflect = (fromObject, toObject) => {
  for(const key in fromObject) {
    toObject[key] = fromObject[key];
  }
};
export const filterMap = (map, property, value) => {
  const filtered = [];
  for(const key in map) {
    if(map[key][property]
        && map[key][property] == value
        && (!map[key].deletedAt || map[key].deletedAt === null)) {
      filtered.push(map[key]);
    }
  }
  return filtered;
};
export const autoLoad = async (mapName, module) => {
  // module is auto load
  // map is not marked as empty
  // when module is not loading
  if (module.autoLoad
      && !module.autoLoad.emptyMap[mapName]
      && module.autoLoad.loading === false
      && (!module.autoLoad.counter || module.autoLoad.counter < 5)) {
    module.autoLoad.loading = true;
    const mapNames = [];
    Object.keys(module).forEach(key => {
      if(module[key] !== null
          && key !== 'autoLoad'
          && typeof(module[key]) == 'object'
          && !Array.isArray(module[key])
          && Object.keys(module[key]).length == 0) {
        mapNames.push(key);
      }
    });
    const response = await module.autoLoad.loader.call();
    if (response) {
      mapNames.forEach(name => {
        if(response[name]) {
          response[name].forEach((item) => {
            if(name == 'staffs') {
              Vue.set(module[name], item.id, item);
            } else {
              module[name][item.id] = item;
            }
          });
          if(Object.keys(module[name]).length == 0) {
            module.autoLoad.emptyMap[name] = true;
          }
        } else {
          //console.warn('MODULE AUTOLOADED BUT API RESPONSE NO DATA FOR THIS MAP <' + name + '>', module);
        }
      });
    }
    if(!module.autoLoad.counter) module.autoLoad.counter = 1;
    else module.autoLoad.counter ++;
    module.autoLoad.loading = false;
  }
};
export const classMap =  {
  'Product': 'articles',
  'Recipe': 'recipes',
  'StockItem': 'stockItems',
  'Category': 'categories',
  'ManagementGroup': 'managementGroups',
  'MixerGroup': 'mixerGroups',
  'Location': 'locationsDummy',
  'Station': 'stations',
  'Stock': 'stocks',
  'User': 'staffs',
  'ReOrder': 'reOrders',
  'Unit': 'units',
  'Container': 'counts',
  'Favorite': 'favorites',
  'Customer': 'customers',
  'Bill': 'bills',
  'PayDetail': 'payDetails',
  // 'BillItem': 'billItems',
  'ProductPosition': 'productPositions',
  'Favorite': 'favorites',
  'Payment': 'payments',
  'Shift': 'shifts',
  'UserGroup': 'userGroups',
  'StockItem': 'stockItems',
};

export const constant =  {
  /* article type */
  SALE_ARTICLE: 0,
  RECIPE_ARTICLE: 1,
  MIXER_ARTICLE: 2,
  ALL_SCREEN: 0,
  /* bill item type */
  NORMAL_ITEM: 0,
  MIXER_ITEM: 1,
  COMMISSION_ITEM: 2,
  TIMER_ITEM: 5,
  /* bill status */
  OPEN_STATUS: 0,
  CLOSED_STATUS: 1,
  VOIDED_STATUS: 2,
  /* role */
  ADMIN: 1,
  CASHIER: 2,
  STAFF: 3,
  SUBTOTAL_PAYTYPE: 100,
  TOTAL_PAYTYPE: 400,
  AMOUNT_PAYTYPE: 700,
  CASH_PAYTYPE: 800,
  CHANGE_PAYTYPE: 1100,
  INVOICE_PAYTYPE: 900,
  PROMOTION: {
    BUY_X_GET_Y: 1,
    DISCOUNT_PERCENT: 2,
    SPECIAL_PRICE: 3,
    DISCOUNT_PRICE: 4,
    FREE_ALL: 5,
  }
};

export default {};
